module.exports = __webpack_public_path__ + "ca7f657c487e11b27bd3d535dea268c9.png";